import { Model } from '@models'
import { Bugsnag } from '@src/config'
import { reducers } from '@src/screens/Tutorials/reducers'
import { FETCH_TUTORIAL } from '../graphql/fetchCMSTutorial'
import { FETCH_TUTORIALS } from '../graphql/fetchCMSTutorials'
import { TutorialResponse, TutorialsResponse } from './tutorials.types'

const DEFAULT_STATE = {
  groups: [],
  tutorials: [],
  currentTutorial: {},
  lastFetchedAt: null,
}

export default class Tutorials {
  namespace = 'tutorials'

  state = DEFAULT_STATE

  effects = {
    fetchTutorials: Model.buildEffect({
      name: `${this.namespace}/fetchTutorials`,
      query: FETCH_TUTORIALS,
      dataPath: 'tutorials',
      caching: false,
      endpoint: 'cms',
      reducers: [
        {
          name: 'setTutorials',
          payload: (response: TutorialsResponse) => {
            return response.data.map((tutorial) => {
              const group = tutorial.attributes.tutorialGroup.data
              // A tutorial assigned to a group whose `kind` is unset will silently
              // fall out of group-based navigation (selector keys off `kind`).
              // Report it so we can backfill the CMS entry instead of debugging
              // a missing "Loading..." screen later.
              if (group && !group.attributes.kind) {
                Bugsnag.notify(
                  new Error(
                    `CMS tutorial "${tutorial.attributes.name}" (id ${tutorial.id}) ` +
                      `is in tutorial group "${group.attributes.title}" (id ${group.id}) ` +
                      `but the group's "kind" field is unset`,
                  ),
                )
              }

              return {
                id: tutorial.id,
                position: tutorial.attributes.position,
                name: tutorial.attributes.name,
                title: tutorial.attributes.title,
                duration: tutorial.attributes.duration,
                description: tutorial.attributes.description,
                buttonText: tutorial.attributes.buttonText,
                image: tutorial.attributes.image,
                tutorialType: tutorial.attributes.tutorialType,
                platform: tutorial.attributes.platform,
                sensorKind: tutorial.attributes.sensorKind,
                tutorialGroupKind: group?.attributes.kind ?? undefined,
                tutorialGroupTitle: group?.attributes.title,
                tutorialGroupDuration: group?.attributes.duration,
                tutorialGroupSummary: group?.attributes.summary,
                tutorialSteps: [],
              }
            })
          },
        },
      ],
    }),
    fetchTutorial: Model.buildEffect({
      name: `${this.namespace}/fetchTutorial`,
      query: FETCH_TUTORIAL,
      dataPath: 'tutorial',
      caching: false,
      endpoint: 'cms',
      reducers: [
        {
          name: 'setTutorial',
          payload: (response: TutorialResponse) => {
            return {
              id: response.data.id,
              ...response.data.attributes,
              tutorialSteps: response.data.attributes.tutorialSteps.data.map((tutorialStep) => ({
                id: tutorialStep.id,
                ...tutorialStep.attributes,
              })),
            }
          },
        },
      ],
    }),
    resetTutorial: Model.buildEffect({
      name: `${this.namespace}/resetTutorial`,
      caching: false,
      reducers: [
        {
          name: 'setTutorial',
          payload: {},
        },
      ],
    }),
  }

  reducers = {
    ...Model.defaultReducers,
    ...reducers,
  }
}
